import type { GetServerSideProps } from 'next';

import { getFixedPageStaticProps } from '@/lib/commonPageStaticProps';
import { ContactUs } from '@/views/ContactUsView';

export const getServerSideProps: GetServerSideProps =
  getFixedPageStaticProps('contact');
export default ContactUs;
